import { render, staticRenderFns } from "./CartaoInformacoesAtendimento.vue?vue&type=template&id=3337008a&scoped=true"
import script from "./CartaoInformacoesAtendimento.vue?vue&type=script&lang=js"
export * from "./CartaoInformacoesAtendimento.vue?vue&type=script&lang=js"
import style0 from "./CartaoInformacoesAtendimento.vue?vue&type=style&index=0&id=3337008a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3337008a",
  null
  
)

export default component.exports